import Course from "@pathwright/ui/src/components/library/Course"
import PropTypes from "prop-types"
import * as PathUI from "../ui/PathUI"

const PreviewPathResource = (props) => {
  return (
    <PathUI.PathResourceContainer layout={props.layout}>
      <Course course={props.pathItem.linked_resource} layout={props.layout} />
    </PathUI.PathResourceContainer>
  )
}

PreviewPathResource.displayName = "PreviewPathResource"

PreviewPathResource.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default PreviewPathResource
